import {FC, useEffect, useState} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'
import '@formatjs/intl-relativetimeformat/locale-data/it'
import '@formatjs/intl-relativetimeformat/locale-data/pt'


import {WithChildren} from '../helpers'
import { set } from 'date-fns'
import { get } from 'http'


const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const [allMessages, setAllMessages] = useState<any>({})
  const [messages, setMessages] = useState<any>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if(allMessages[locale] !== undefined){
      setMessages(allMessages[locale])
      setIsLoading(false)
      return
    }

    const fetchMessage = async (locale: string) => {
      try {
        setIsLoading(true)
        const fetchIndex = await fetch(`/media/locale/index.json`)
        const index = await fetchIndex.json()
        let messages: any = {}
     
        for(let f of index){
          const fetchMessage = await fetch(`/media/locale/${locale}/${f}.json`)
          const data = await fetchMessage.json()
          messages = {...messages, ...data}
        }
        
        setMessages(messages)
        setAllMessages(prev => ({...prev, [locale]: messages}))
        setIsLoading(false)
      } catch (error) {
        console.error('Error loading translations:', error)
        setIsLoading(false)
      }
    }
    
    fetchMessage(locale)
  }, [locale])
  

  if (isLoading) {
    return <>
    <div className="splash-screen-lang">
      <img
        src="/media/logos/INSIGHT-negativo.png"
        className="dark-logo"
        alt="Insight dark logo"
      />
      <img
        src="/media/logos/INSIGHT-negativo.png"
        className="light-logo"
        alt="Insight light logo"
      />
      <span>Loading Language...</span>
    </div>
    </>
  }

  return (
    <IntlProvider locale={locale} messages={messages || {}}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
